module.exports = __webpack_public_path__ + "img/6 padres.fd688847.jpg";